/** @file Looks up a compiled index by document id; a dangling reference is NOT_FOUND at its path. */
import { throwError } from '@pose2d/format/throwError';
import type { EntityKind } from '@pose2d/format/types';

/** `map.get(id)`, or throws NOT_FOUND `{ kind, ref: id }` at `path`. */
export function requireCompiledIndex(map: ReadonlyMap<string, number>, id: string, kind: EntityKind, path: string): number {
  const i = map.get(id);
  if (i === undefined) throwError('NOT_FOUND', { kind, ref: id }, { path });
  return i;
}
